import { render } from "./tw-pie.vue?vue&type=template&id=3000c046"
import script from "./tw-pie.vue?vue&type=script&lang=js"
export * from "./tw-pie.vue?vue&type=script&lang=js"
script.render = render

export default script